import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { FiXCircle, FiArrowRight, FiRefreshCw } from 'react-icons/fi';

const PaymentFailed = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Auto-redirect to pricing after 10 seconds
        const timer = setTimeout(() => {
            navigate('/pricing');
        }, 10000);
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="min-h-screen bg-bg_primary flex items-center justify-center px-4">
            <div className="max-w-md w-full text-center">
                {/* Animated error icon */}
                <div className="flex items-center justify-center mb-8">
                    <div
                        style={{
                            width: 100,
                            height: 100,
                            borderRadius: '50%',
                            background: 'rgba(239,68,68,0.12)',
                            border: '2px solid rgba(239,68,68,0.4)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            animation: 'shake 0.6s ease, pulse 2s 0.6s infinite',
                        }}
                    >
                        <FiXCircle style={{ color: '#ef4444', fontSize: 48 }} />
                    </div>
                </div>

                <h1
                    style={{
                        fontSize: '2rem',
                        fontWeight: 700,
                        color: '#ffffff',
                        marginBottom: '0.75rem',
                    }}
                >
                    Payment Failed
                </h1>

                <p
                    style={{
                        color: '#9ca3af',
                        fontSize: '1rem',
                        lineHeight: 1.6,
                        marginBottom: '2rem',
                    }}
                >
                    Your payment could not be processed. This may be due to insufficient
                    funds, an expired card, or the transaction was cancelled. Please try
                    again or use a different payment method.
                </p>

                {/* Common reasons */}
                <div
                    style={{
                        background: 'rgba(239,68,68,0.07)',
                        border: '1px solid rgba(239,68,68,0.25)',
                        borderRadius: 10,
                        padding: '1rem 1.25rem',
                        marginBottom: '2rem',
                        textAlign: 'left',
                    }}
                >
                    <p
                        style={{
                            color: '#f87171',
                            fontWeight: 600,
                            fontSize: '0.85rem',
                            marginBottom: '0.5rem',
                        }}
                    >
                        Common reasons for failure:
                    </p>
                    <ul style={{ color: '#9ca3af', fontSize: '0.82rem', paddingLeft: '1rem', lineHeight: 1.8 }}>
                        <li>Insufficient funds in your account</li>
                        <li>Card expired or incorrect details</li>
                        <li>Transaction cancelled by you</li>
                        <li>Payment blocked by your bank</li>
                    </ul>
                </div>

                {/* Action buttons */}
                <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
                    <button
                        onClick={() => navigate('/pricing')}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 8,
                            background: '#ef4444',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 8,
                            padding: '0.75rem 1.5rem',
                            fontSize: '0.95rem',
                            fontWeight: 600,
                            cursor: 'pointer',
                            transition: 'background 0.2s',
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.background = '#dc2626')}
                        onMouseOut={(e) => (e.currentTarget.style.background = '#ef4444')}
                    >
                        <FiRefreshCw />
                        Try Again
                    </button>

                    <button
                        onClick={() => navigate('/home')}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 8,
                            background: 'transparent',
                            color: '#9ca3af',
                            border: '1px solid rgba(156,163,175,0.35)',
                            borderRadius: 8,
                            padding: '0.75rem 1.5rem',
                            fontSize: '0.95rem',
                            fontWeight: 600,
                            cursor: 'pointer',
                            transition: 'border-color 0.2s, color 0.2s',
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.borderColor = 'rgba(156,163,175,0.7)';
                            e.currentTarget.style.color = '#ffffff';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.borderColor = 'rgba(156,163,175,0.35)';
                            e.currentTarget.style.color = '#9ca3af';
                        }}
                    >
                        Go to Dashboard
                        <FiArrowRight />
                    </button>
                </div>

                <p style={{ color: '#6b7280', fontSize: '0.8rem', marginTop: '1.5rem' }}>
                    You will be redirected to the pricing page in 10 seconds…
                </p>
            </div>

            <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20% { transform: translateX(-6px); }
          40% { transform: translateX(6px); }
          60% { transform: translateX(-4px); }
          80% { transform: translateX(4px); }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.05); opacity: 0.85; }
        }
      `}</style>
        </div>
    );
};

export default PaymentFailed;
